// @flow
/**
 * Created by Mike Chung on 3/15/18.
 */

import {Country} from "../model/Country";
import * as _ from "lodash";
import config from "../config/config";
import type {RoleConfig, RoleConfigs} from "../types/utilityTypes";

export function findCountryNameBySymbol(countries: Array<Country>, symbol: ?string) {

    return _.chain(countries).find(['symbol', symbol]).defaultTo({name: symbol}).value().name;
}
export function findCountryNameByCountryCode(countries: Array<Country>, countryCode: ?string) {

    return _.chain(countries).find(['symbol', countryCode]).defaultTo({name: countryCode}).value().name;
}

export function computeUserConfigs(userRoles: Array<string>): RoleConfig {

    let roleConfigs: RoleConfigs = config.roleConfigs;
    let configs: Array<RoleConfig> = _.chain(userRoles).map((role: string) => roleConfigs[role]).compact().value();

    let result: RoleConfig = _.reduce(configs, (result: RoleConfig, value: RoleConfig) => {

        const idleTimeout: number = Math.max(result.idleTimeout || 0, value.idleTimeout);
        const allowToLinkEBadge: boolean = result.allowToLinkEBadge || value.allowToLinkEBadge;
        const allowPhotoEBadgeManagement: boolean = result.allowPhotoEBadgeManagement || value.allowPhotoEBadgeManagement;
        const allowToVerify: boolean = result.allowToVerify || value.allowToVerify;
        const allowToDelete: boolean = result.allowToDelete || value.allowToDelete;
        const allowGenerateQrCode: boolean = result.allowGenerateQrCode || value.allowGenerateQrCode;
        return {idleTimeout, allowToLinkEBadge, allowPhotoEBadgeManagement, allowToVerify, allowToDelete, allowGenerateQrCode};
    }, roleConfigs['default']);

    return result;
}

export function xand(str1: ?string, str2: ?string): boolean {

    return (!!str1 && !!str2) || (!str1 && !str2);
}


// WEBPACK FOOTER //
// ./src/helpers/utils.js